/**
 * @name ReceivableUnits
 * @description This module exposes functions
 *              related to the `/receivable-units` path.
 *
 * @module ReceivableUnits
 **/

import routes from '../routes'
import request from '../request'

/**
   * `GET /receivable-units`
   * Makes a request to /receivable-units
   *
   * @param {Object} opts An options params which
   *                      is usually already bound
   *                      by `connect` functions.
   *
   * @param {Object} body
   * @param {String} [body.start_date]
   * @param {String} [body.end_date]
  */
const all = (opts, body) =>
  request.get(opts, routes.receivableUnits.all, body)

export default {
  all,
}



/** WEBPACK FOOTER **
 ** ./resources/receivableUnits.js
 **/